function axiomsSubDomain() {
    let url
    switch (location.hostname) {
        case 'app.us.axioms.io':
            url = '.us.axioms.io'
            break;

        case 'control.us.axioms.io':
            url = '.us.axioms.io'
            break;

        case 'control.us.uat.axioms.io':
            url = '.us.uat.axioms.io'
            break;

        default:
            url = '.example.com'
            break;
    }
    return url
}

export default axiomsSubDomain;